import React, { useState, useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import emailjs from '@emailjs/browser';

const FormVideoHelpEn = () => {
    const [choiceOS, setChoiceOS] = useState('- Select -');
    const [deviceType, setDeviceType] = useState('- Select -');
    const [deviceOther, setDeviceOther] = useState('');
    const [choiceProv, setChoiceProv] = useState('- Select -');
    const [connection, setConnection] = useState('');
    const [otherOS, setOtherOS] = useState('');
    const [versionOS, setVersionOS] = useState('');
    const [browser, setBrowser] = useState('');
    const [browserOther, setBrowserOther] = useState('');
    const [city, setCity] = useState('');
    const [speed, setSpeed] = useState('');
    const [errors, setErrors] = useState('');
    const [errorDetails, setErrorDetails] = useState('');
    const [vod, setVod] = useState('');
    const [live, setLive] = useState('');
    const [cpacApp, setCpacApp] = useState('');
    const [name, setName] = useState('');
    const [emailAddress, setEmailAddress] = useState(''); 
    const [messageSent, setMessageSent] = useState();
    const [messageError, setMessageError] = useState();
    const [captchaValue, setCaptchaValue] = useState(null); 
    const captchaKey = process.env.REACT_APP_RECAPTCHA_KEY;  
    const isEmail = (email) => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);
    
    const renderTextField = (inputData, value, onChange) => {
        return (
            <>
            <label className='field_label' htmlFor={inputData.id}>{inputData.label}{inputData.required ? <span className='field_required'>{inputData.required}</span> : ''}</label>
            <div className='input_container input_container_text'>
                <input name={inputData.name} 
                id={inputData.id} 
                type={inputData.type} 
                value={ value } 
                className='medium' 
                aria-invalid="false" 
                aria-required={inputData.ariaRequired}
                aria-describedby={inputData.description}
                onChange={(e) => onChange(e.target.value)}>
                </input>
                {inputData.message ? <p className='hidden' id={inputData.description}>{inputData.message}</p> : ""}
            </div>
            </>
        );
    }

    const renderTextArea = (inputData, value, onChange) => {
        return(
            <>
            <label className='field_label' htmlFor={inputData.id}>{inputData.label}{inputData.required ? <span className='field_required'>*</span> : ""}</label>
            <div className='input_container input_container_textarea'>
                <textarea name={inputData.name} 
                id={inputData.id} 
                className='textarea medium' 
                value={value} 
                aria-invalid="false" rows='10' cols='50'
                onChange={(e) => onChange(e.target.value)}/>
            </div>
            </>
        );
    }

    const renderEmailField = (inputData, value, onChange) => {
        return(
            <>
            <label className='field_label' htmlFor={inputData.id}>{inputData.label}{inputData.required ? <span className='field_required'>*</span> : ""}</label>
            <div className='input_container input_container_email'>
                <input 
                name={inputData.name} 
                id={inputData.id} 
                type='email' 
                value={value} 
                className='medium' 
                aria-required="true" aria-invalid="false" aria-describedby="field_description_email"
                onChange={(e) => onChange(e.target.value)}>
                </input>
            </div>
            <div className={`sp_field_description ${isEmail(value) ? "" : "invalid"}`} id="field_description_email">{!isEmail(value) ? inputData.description : "Thank You"}</div>
            </>
        );
    }

    const renderCheckRadio = (inputData, value, onChange) => {
        return(
            <>
            <label className='field_label'>{inputData.label}{inputData.required ? <span className='field_required'>*</span> : ""}</label>
            <div aria-activedescendant={inputData.choices[0].value} className='input_container input_container_checkbox' role={inputData.type === 'radio' ? "radiogroup" : "checkbox"} tabIndex="-1">
            {inputData.choices.map(({type, name, value, label}, i) => <div key={`${inputData.name}-${i}`}className="radioCheck"><input name={name} type={type} className={type} value={value} id={type === 'radio' ? value : name} onChange={(e) => onChange(e.target.value)}></input><label htmlFor={type === 'radio' ? value : name}>{label}</label></div>)}
            </div>
            </>
        )
    }

    const renderDropdown = (inputData, value, onChange) => {
        return (
            <>
                <label className='field_label' htmlFor={inputData.id}>{inputData.label}{inputData.required ? <span className='field_required'>*</span> : ""}</label>
                <div className='input_container input_container_select'>
                    <select 
                        name={inputData.name} 
                        id={inputData.id} 
                        className='medium field_select' 
                        aria-required="true" 
                        aria-invalid="false"
                        value={ value }
                        onChange={(e) => onChange(e.target.value)}
                    >
                        {inputData.option.map(({value, label}, i) => <option key={`${inputData.name}-${i}`} value={value}>{label}</option>)}
                    </select>
                </div>
            </>
        )
    }

    const renderChoiceOs = () => {
        const inputData = {
            name: 'operating-system-choice',
            id: 'OSselector',
            label: 'Operating System',
            option: [
                {label: '- Select -', value: '- Select -'},
                {label: 'Windows', value: 'Windows'},
                {label: 'Mac', value: 'Mac'},
                {label: 'Linux', value: 'Linux'},
                {label: 'Apple iOS - iPad / iPhone', value: 'Apple iOS - iPad / iPhone'},
                {label: 'Andriod', value: 'Andriod'},
                {label: 'Other', value: 'Other'},
            ],
            required: true,
        };

        return renderDropdown(inputData, choiceOS, setChoiceOS);
    }

    const renderOtherOS = () => {
        const inputData = {
            name: 'other-OS',
            id: 'otherOS',
            label: 'Operating System - Other',
            type: 'text',
            value: '',
            required: false,
            ariaRequired: 'false',
            description: 'field_description_OSother',
            message: 'If your operating system is not in the list, please provide your operating system name.'
        }
        return renderTextField(inputData, otherOS, setOtherOS);
    }

    const renderVersionOS = () => {
        const inputData = {
            name: 'Operating-system-version',
            id: 'OSversion',
            label: 'Operating System version',
            type: 'text',
            value: '',
            required: false,
            ariaRequired: 'false',
            description: 'field_description_OSversion',
            message: 'If you know the version of your operating system, please provide it here.'
        }
        return renderTextField(inputData, versionOS, setVersionOS);
    }

    const renderDeviceType = () => {
        const inputData = {
            name: 'device-type',
            id: 'deviceType',
            label: 'Device Type',
            option: [
                {label: '- Select -', value: '- Select -'},
                {label: 'Desktop', value: 'Desktop'},
                {label: 'Laptop', value: 'Laptop'},
                {label: 'Tablet', value: 'Tablet'},
                {label: 'Phone', value: 'Phone'},
                {label: 'Smart TV', value: 'Smart TV'},
                {label: 'Game Console', value: 'Game Console'},
                {label: 'Other', value: 'Other'},
            ],
            required: true,
        };

        return renderDropdown(inputData, deviceType, setDeviceType);
    }

    const renderDeviceOther = () => {
        const inputData = {
            name: 'other-device',
            id: 'deviceOther',
            label: 'Device Type - Other',
            type: 'text',
            value: '',
            required: false,
            ariaRequired: 'false',
            description: 'field_description_deviceOther',
            message: 'If your device type is not in the list, please provide the type of device you are using.'
        }
        return renderTextField(inputData, deviceOther, setDeviceOther);
    }

    const renderBrowser = () => {
        const inputData = {
            name: 'browser',
            id: 'browserSelect',
            label: 'Browser Type',
            required: true,
            option: [
                {label: '- Select -', value: '- Select -'},
                {label: 'Edge', value: 'Edge'},
                {label: 'Firefox', value: 'Firefox'},
                {label: 'Safari', value: 'Safari'},
                {label: 'Chrome', value: 'Chrome'},
                {label: 'Other', value: 'Other'},
            ],
        };

        return renderDropdown(inputData, browser, setBrowser);
    }

    const renderBrowserOther = () => {
        const inputData = {
            name: 'browser_other',
            id: 'other-browser',
            label: 'Browser - Other',
            type: 'text',
            value: '',
            required: false,
            ariaRequired: 'false',
            description: 'field_description_browserOther',
            message: 'If your web browser is not in the list, please provide the name of your browser.'
        }
        return renderTextField(inputData, browserOther, setBrowserOther);
    }

    const renderCity = () => {
        const inputData = {
            name: 'city',
            id: 'location',
            label: 'Your City',
            type: 'text',
            value: '',
            required: true,
            ariaRequired: 'true',
            description: 'field_description_city',
            message: 'Please provide your location.'
        }
        return renderTextField(inputData, city, setCity);
    }

    const renderChoiceProv = () => {
        const inputData = {
            name: 'province-territory',
            id: 'province',
            label: 'Your Province / Territory',
            option: [
                {label: 'Select your Province or Territory', value: 'Province-Territory'},
                {label: 'British Columbia', value: 'British Columbia'},
                {label: 'Alberta', value: 'Alberta'},
                {label: 'Saskatchewan', value: 'Saskatchewan'},
                {label: 'Manitoba', value: 'Manitoba'},
                {label: 'Ontario', value: 'Ontario'},
                {label: 'Québec', value: 'Québec'},
                {label: 'New Brunswick', value: 'New Brunswick'},
                {label: 'Prince Edward Island', value: 'Prince Edward Island'},
                {label: 'Nova Scotia', value: 'Nova Scotia'},
                {label: 'Newfoundland and Labrador', value: 'Newfoundland and Labrador'},
                {label: 'Nunavut', value: 'Nunavut'},
                {label: 'Northwest Territories', value: 'Northwest Territories'},
                {label: 'Yukon', value: 'Yukon'},
            ],
            required: true,
        };

        return renderDropdown(inputData, choiceProv, setChoiceProv);
    }

    const renderConnection = () => {
        const inputData = {
            name: 'connection',
            id: 'internet-connection',
            label: 'Internet Connection Type',
            required: true,
            option: [
                {label: '- Select -', value: '- Select -'},
                {label: 'Cable', value: 'Cable'},
                {label: 'Fibre', value: 'Fibre'},
                {label: 'Satellite', value: 'Satellite'},
                {label: 'Fixed Wireless', value: 'Fixed Wireless'},
                {label: 'Mobile', value: 'Mobile'},
                {label: 'DSL', value: 'DSL'},
            ]
        };

        return renderDropdown(inputData, connection, setConnection);
    }

    const renderSpeed = () => {
        const inputData = {
            name: 'connection-speed',
            id: 'speed',
            label: 'Connection Speed in Mbps (if known)',
            type: 'text',
            value: '',
            required: false,
            ariaRequired: 'false',
            description: 'field_description_speed',
            message: 'If you know your connection speed, please provide it here.'
        }
        return renderTextField(inputData, speed, setSpeed);
    }

    const renderErrors = () => {
        const inputData = {
            name: 'errors',
            id: 'errorsRB',
            label: 'Do any error messages appear?',
            type: 'radio',
            choices: [
                {type: 'radio', name: 'errors', label: 'Yes', value: 'errors-yes'},
                {type: 'radio', name: 'errors', label: 'No', value: 'errors-no'},                
            ],
            required: false,
        };

        return renderCheckRadio(inputData, errors, setErrors);
    }

    const renderErrorDetails = () => {
        const inputData = {
            name: 'error_details',
            id: 'errorDetails',
            label: 'Please explain the details of the problem you are experiencing.',
            required: false,
        }
        return renderTextArea(inputData, errorDetails, setErrorDetails);
    }

    const renderLive = () => {
        const inputData = {
            name: 'live',
            id: 'liveURL',
            label: 'For Live Streams',
            type: 'text',
            value: '',
            required: false,
            ariaRequired: 'false',
            description: 'field_description_live',
            message: 'Please paste the URL of the live stream you are having trouble with.'
        };

        return renderTextField(inputData, live, setLive);
    }

    const renderVod = () => {
        const inputData = {
            name: 'vod',
            id: 'vodURL',
            label: 'For Video-on-Demand',
            type: 'text',
            value: '',
            required: false,
            ariaRequired: 'false',
            description: 'field_description_VOD',
            message: 'Please paste the URL of the video you are having trouble with.'
        }
        return renderTextField(inputData, vod, setVod);
    }

    const renderCpacApp = () => {
        const inputData = {
            name: 'CPAC app',
            id: 'cpacApp',
            label: 'Is the problem related to our CPAC TV 2 Go app?',
            type: 'checkbox',
            choices: [
                {type: 'checkbox', name: 'cpac_app', label: 'Yes', value: 'yes'},
            ],
            required: false,
        };

        return renderCheckRadio(inputData, cpacApp, setCpacApp);
    }

    const renderName = () => {
        const inputData = {
            name: 'your-name',
            id: 'name',
            label: 'Name',
            type: 'text',
            value: '',
            ariaRequired: 'false',
            required: false,
            description: 'field_description_name',
            message: 'Your name is optional.'
        }
        return renderTextField(inputData, name, setName);
    }

    const renderEmailDetails = () =>{
        const inputData = {
            name: 'email',
            id: 'emailAddress',
            label: 'Email',
            required: true,
            description: 'Please provide a valid email address.',
        }
        return renderEmailField(inputData, emailAddress, setEmailAddress);
    }

    const captchaRef = useRef(null);
    
    const onReCaptchaChange = (value) => {
        setCaptchaValue(value);
    }

    const buttonDisabled = (captchaValue) => {
        return (
            !captchaValue ? "disabled" : ""
        )
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        captchaRef.current.reset();
        const templateParams = { 
            senderLanguage: "English",
            senderName: name,
            senderEmail: emailAddress, 
            senderCity: city, 
            senderProvince: choiceProv,
            senderOS: choiceOS === "Other" ? otherOS : choiceOS, 
            senderOSversion: versionOS,
            senderDeviceType: deviceType === "Other" ? deviceOther : deviceType,
            senderBrowser: browser === "Other" ? browserOther : browser,
            senderConnectType: connection,
            senderConnectSpeed: speed,
            senderErrors: errors,
            senderErrorDetails: errorDetails,
            senderLiveStreams: live,
            senderVOD: vod,
            senderApp: cpacApp
        };
        emailjs.send('outlook_service', 'video_help_template', templateParams, process.env.REACT_APP_EMAILJS_KEY)
            .then(function() {
                setMessageSent(true);
                e.target.reset(); // reset the form
            }, function(error) {
                setMessageError(true);
            });
    }

    return (
        <>
        
        {
            messageSent ? <h2 className='form_wrapper message_success'>Thank you for your submission.</h2> : messageError ? <h2 className='form_wrapper message_fail'>Sorry there was a problem with your submission. Please try again later.</h2> :
        <div id="form_wrapper" className="form_wrapper">
            <form onSubmit={(e) => handleSubmit(e)}>
                <div className="form_body">
                    { renderChoiceOs() }
                    { choiceOS === 'Other' ? renderOtherOS() : '' }
                    { renderVersionOS() }
                    { renderDeviceType() }
                    { deviceType === 'Other' ? renderDeviceOther() : ''}
                    { renderBrowser() }
                    { browser === 'Other' ? renderBrowserOther() : '' }
                    { renderCity() }
                    { renderChoiceProv() }
                    { renderConnection() }
                    { renderSpeed() }
                    { renderErrors() }
                    { renderErrorDetails() }
                    { renderLive() }
                    { renderVod() }
                    { renderCpacApp() }
                    { renderName() }
                    { renderEmailDetails() }

                </div>
                <ReCAPTCHA sitekey={captchaKey} ref={captchaRef} onChange={onReCaptchaChange} />
                <div className='form_footer left_label'>
                <button type="submit" name='submit' value='submit' className="btn--primary" disabled={buttonDisabled(captchaValue)}>Submit</button>
                </div>
            </form>
        </div>
        }
        </>
    )
}

export default FormVideoHelpEn;